import React from 'react';
import styles from '../styles/CompletionScreen.module.scss';
import { ReactComponent as PropdocsLogo } from '../../../shared/icons/propdocs-logo.svg';

interface CompletionScreenProps {
  document: {
    title: string;
  };
  downloadUrl: string;
  onClose: () => void;
}

export const CompletionScreen: React.FC<CompletionScreenProps> = ({ document, downloadUrl, onClose }) => {
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.backgroundBlur}></div>
      <div className={styles.completionContainer}>
        <div className={styles.completionCard}>
          <div className={styles.header}>
            <div className={styles.logoContainer}>
              <PropdocsLogo className={styles.logo} />
            </div>

            <div className={styles.successIcon}>✓</div>

            <h1 className={styles.title}>Document Signed Successfully!</h1>
          </div>

          <p className={styles.message}>
            Your signature has been successfully captured and securely stored digitally. You'll receive a copy of the
            agreement and any required further instructions via email.
          </p>

          <div className={styles.footer}>
            <div className={styles.divider}></div>
            <p className={styles.propdocsPromo}>
              Want better contract management?{' '}
              <a href="https://www.propdocs.com" target="_self">
                Try Propdocs Now
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
